import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface UserActivityData {
  date: string;
  activeUsers: number;
  newUsers: number;
}

interface UserActivityChartProps {
  data: UserActivityData[];
}

const UserActivityChart = ({ data }: UserActivityChartProps) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="activeUsers" fill="#3b82f6" name="Active Users" />
        <Bar dataKey="newUsers" fill="#10b981" name="New Users" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default UserActivityChart;
